import React from 'react'

import {useNavigate} from 'react-router'

import { Row,Container, Button } from 'react-bootstrap'

import { Content,Img,SubLabel,Label,Footer } from './styles'

import ErrorShop from '../../assets/naoAprovado.png'

export default function ErrorPage () {

  const navigate = useNavigate()

  let message = null
  let error_description = null
  const error  = new URLSearchParams(location.search).get("error") 
  if (error) {
    const obj = JSON.parse(error)
    message = obj.message
    error_description = obj.error_description
  } else {
    message = 'Ocorreu um erro'
  }
  const finalMessage = message || error_description
  return (
    <div className="wl-page">
          <Container>
              <Content>
                <Row className="justify-content-center">
                  <Img src={ErrorShop} alt="Order" />
                </Row>
                <Row className="text-center">
                  <Label>Ocorreu um erro</Label>
                  <SubLabel>{ finalMessage || `Não foi possível completar sua operação.`}</SubLabel>
                </Row>
              </Content>
          </Container>
          <Footer>
              <Button type="button" className="btn-default-wl"
                      onClick={() => navigate('/loja')}>VOLTAR PARA A HOME</Button>
          </Footer>
  </div>
  )
}
